import { ContactGroup } from '@app/core/interfaces/c5/contact-group';
import { FormMapping } from '@app/utils/form-mapping/decorators/form-mapping';
import { FormMappingAttribute } from '@app/utils/form-mapping/decorators/form-mapping-attribute';
import {
  Email,
  IntInput,
  MaxLength,
  PhoneNumber,
  RequireAny,
} from '@app/utils/form-mapping/helpers/default-attributes';
import { FormMappingModel } from '@app/utils/form-mapping/models/form-mapping-model';

@FormMapping()
export class UpdateContactFormModel extends FormMappingModel {
  @MaxLength(50)
  @RequireAny('firstName', 'lastName', 'company')
  firstName: string;

  @MaxLength(50)
  @RequireAny('firstName', 'lastName', 'company')
  lastName: string;

  @MaxLength(50)
  @RequireAny('firstName', 'lastName', 'company')
  company: string;

  @MaxLength(50)
  department: string;

  @MaxLength(50)
  jobTitle: string;

  @MaxLength(50)
  note: string;

  @PhoneNumber
  mobilePhone: string;

  @PhoneNumber
  businessPhone: string;

  @PhoneNumber
  businessFax: string;

  @PhoneNumber
  homePhone: string;

  @Email
  email: string;

  @Email
  email2: string;

  @IntInput
  vipPriority: number;

  @FormMappingAttribute('groups')
  contactGroups: ContactGroup[];
}
